export default "__VITE_ASSET__Cw15pwqM__"